module.exports = __webpack_public_path__ + "img/solar_panel_icon_error.d3f81c24.svg";